import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EveningReview } from '@/features/review/EveningReview'
import { WeeklyReview } from '@/features/review/WeeklyReview'
import { PageHeading } from '@/components/PageHeading'
import { Button } from '@/components/ui/button'

/**
 * Which review is showing lives in the URL, so it survives a reload and the
 * back button does what you expect.
 */
const search = z.object({
  span: z.enum(['day', 'week']).default('day'),
})

export const Route = createFileRoute('/review')({
  validateSearch: search,
  component: ReviewPage,
})

function ReviewPage() {
  const { span } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="py-6 sm:py-8">
      <PageHeading
        title="Review"
        meta={span === 'day' ? 'Close the day' : 'Look at the week'}
      />

      <div className="mt-4 flex gap-1.5">
        {(
          [
            ['day', 'Tonight'],
            ['week', 'This week'],
          ] as const
        ).map(([value, label]) => (
          <Button
            key={value}
            type="button"
            size="sm"
            variant={span === value ? 'default' : 'outline'}
            aria-pressed={span === value}
            className="min-h-11 sm:min-h-8"
            onClick={() => void navigate({ search: { span: value } })}
          >
            {label}
          </Button>
        ))}
      </div>

      <div className="mt-6">
        {span === 'day' ? <EveningReview /> : <WeeklyReview />}
      </div>
    </div>
  )
}
